import { useContext } from "react";
import { ReportModalContext, IReportModal } from "./ReportModalContext";

export const useReportModal = () => {
    if (!ReportModalContext)
        throw new Error("useReportModal must be under ReportModalProvider");
    return useContext<IReportModal | undefined>(ReportModalContext);
};